export enum ConfigName {
  apollo = 'codemiro-layout-apollo',
  zeus = 'codemiro-layout-zeus',
  hermes = 'codemiro-layout-hermes',
  poseidon = 'codemiro-layout-poseidon',
  ares = 'codemiro-layout-ares',
  ikaros = 'codemiro-layout-ikaros',
}
